var _defs, _g, _g2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.64 54.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "21.67 30.02 38.62 30.02 40.86 19.53 19.44 19.53 21.67 30.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M27.32,0C12.23,0,0,12.23,0,27.32s12.23,27.32,27.32,27.32,27.32-12.23,27.32-27.32S42.41,0,27.32,0Zm-4.93,45.22c-1.84,0-3.33-1.5-3.33-3.33s1.5-3.33,3.33-3.33,3.33,1.5,3.33,3.33-1.5,3.33-3.33,3.33Zm14.26,0c-1.84,0-3.33-1.5-3.33-3.33s1.5-3.33,3.33-3.33,3.33,1.5,3.33,3.33-1.5,3.33-3.33,3.33Zm7.74-26.96l-2.91,13.69c-.16,.74-.81,1.27-1.57,1.27H21.46c-.4,0-.73,.33-.73,.73s.33,.73,.73,.73h18.46c.88,0,1.6,.72,1.6,1.6s-.72,1.6-1.6,1.6H21.46c-2.17,0-3.93-1.76-3.93-3.93,0-1.07,.43-2.04,1.13-2.75l-3.47-16.34h-3.37c-.88,0-1.6-.72-1.6-1.6s.72-1.6,1.6-1.6h4.67c.76,0,1.41,.53,1.57,1.27l.72,3.4h24.07c.48,0,.94,.22,1.24,.59s.42,.87,.32,1.34Z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingIcon);
export default __webpack_public_path__ + "static/media/shopping-icon.387a9835748fb3216907ff9b4c0338d3.svg";
export { ForwardRef as ReactComponent };